/* tslint:disable */
/* eslint-disable */
/**
 * ChildAware Website
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { WorkingWithChildrenCheckSingleStatusCheckCommand } from '../models';
import { WorkingWithChildrenCheckSingleStatusCheckResponse } from '../models';
/**
 * WorkingWithChildrenCheckApi - axios parameter creator
 * @export
 */
export const WorkingWithChildrenCheckApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {WorkingWithChildrenCheckSingleStatusCheckCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkingwithchildrencheckSinglestatuscheckPost: async (body?: WorkingWithChildrenCheckSingleStatusCheckCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workingwithchildrencheck/singlestatuscheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkingWithChildrenCheckApi - functional programming interface
 * @export
 */
export const WorkingWithChildrenCheckApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {WorkingWithChildrenCheckSingleStatusCheckCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkingwithchildrencheckSinglestatuscheckPost(body?: WorkingWithChildrenCheckSingleStatusCheckCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkingWithChildrenCheckSingleStatusCheckResponse>> {
            const localVarAxiosArgs = await WorkingWithChildrenCheckApiAxiosParamCreator(configuration).apiWorkingwithchildrencheckSinglestatuscheckPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * WorkingWithChildrenCheckApi - factory interface
 * @export
 */
export const WorkingWithChildrenCheckApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {WorkingWithChildrenCheckSingleStatusCheckCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkingwithchildrencheckSinglestatuscheckPost(body?: WorkingWithChildrenCheckSingleStatusCheckCommand, options?: any): AxiosPromise<WorkingWithChildrenCheckSingleStatusCheckResponse> {
            return WorkingWithChildrenCheckApiFp(configuration).apiWorkingwithchildrencheckSinglestatuscheckPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkingWithChildrenCheckApi - object-oriented interface
 * @export
 * @class WorkingWithChildrenCheckApi
 * @extends {BaseAPI}
 */
export class WorkingWithChildrenCheckApi extends BaseAPI {
    /**
     * 
     * @param {WorkingWithChildrenCheckSingleStatusCheckCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingWithChildrenCheckApi
     */
    public apiWorkingwithchildrencheckSinglestatuscheckPost(body?: WorkingWithChildrenCheckSingleStatusCheckCommand, options?: any) {
        return WorkingWithChildrenCheckApiFp(this.configuration).apiWorkingwithchildrencheckSinglestatuscheckPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
